exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/traev/Sites/btt/src/app/game/dnd5e-sheet/dnd5e-sheet.component.scss
// module id = ../../../../../src/app/game/dnd5e-sheet/dnd5e-sheet.component.scss
// module chunks = main